import React from 'react';
import { Quote, ArrowDown } from 'lucide-react';
import { useInView } from '../hooks/useInView';
const testimonials = [{
  quote: 'Llevaba meses con un nudo en el estómago cada vez que alguien tocaba la puerta. Esta guía no me quitó el miedo, pero ahora sé qué pasos seguir y eso me da algo de paz.',
  author: 'Ana R.',
  location: 'Houston, TX'
}, {
  quote: 'Mi esposo y yo la leímos juntos un domingo. Nos ayudó a organizar los documentos que teníamos regados y a hablar con nuestros hijos sobre qué hacer en una emergencia. Algo que veníamos posponiendo.',
  author: 'Jorge M.',
  location: 'Los Ángeles, CA'
}, {
  quote: 'No soy de leer mucho, pero esta guía está escrita de forma clara y directa. Me sirvió para entender cosas que ni mi vecina, que lleva 20 años aquí, sabía.',
  author: 'Lucía P.',
  location: 'Chicago, IL'
}];
export function Testimonials() {
  const [headerRef, headerInView] = useInView();
  const [gridRef, gridInView] = useInView();
  const [ctaRef, ctaInView] = useInView();
  return <section className="py-24 bg-white text-[#1a1a2e]" data-id="element-203">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-204">
        <div ref={headerRef} className={`text-center mb-16 animate-on-scroll ${headerInView ? 'in-view' : ''}`} data-id="element-205">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-[#1a56a0] mb-4 uppercase tracking-wide" data-id="element-206">
            Lo Que Dicen Nuestros Lectores y Lectoras
          </h2>
          <p className="text-gray-500 font-sans text-base max-w-xl mx-auto mt-2" data-id="element-207">
            Historias reales de familias que decidieron prepararse.
          </p>
          <div className="w-24 h-1 bg-[#c0392b] mx-auto mt-6" data-id="element-208" />
        </div>

        <div ref={gridRef} className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12" data-id="element-209">
          {testimonials.map((testimonial, index) => <div key={index} className={`relative p-8 bg-gray-50 border-l-4 border-[#c0392b] shadow-sm animate-on-scroll delay-${index * 2} ${gridInView ? 'in-view' : ''}`} data-id="element-210">
              <Quote className="absolute top-6 left-6 w-10 h-10 text-[#c0392b]/20 rotate-180" data-id="element-211" />

              <blockquote className="relative z-10 mt-4" data-id="element-212">
                <p className="font-serif text-lg md:text-xl italic text-[#1a56a0] leading-relaxed mb-6" data-id="element-213">
                  "{testimonial.quote}"
                </p>
                <footer className="flex flex-col border-t border-gray-200 pt-4" data-id="element-214">
                  <cite className="font-sans font-bold text-[#1a56a0] not-italic uppercase tracking-wide text-sm" data-id="element-215">
                    {testimonial.author}
                  </cite>
                  <span className="font-sans text-sm text-gray-500 mt-1" data-id="element-216">
                    {testimonial.location}
                  </span>
                </footer>
              </blockquote>
            </div>)}
        </div>

        {/* Micro-CTA */}
        <div ref={ctaRef} className={`text-center mt-16 animate-on-scroll delay-4 ${ctaInView ? 'in-view' : ''}`} data-id="element-217">
          <p className="text-gray-600 font-sans text-base mb-4" data-id="element-218">
            Únete a las familias que ya dieron el primer paso.
          </p>
          <a href="#pricing" className="inline-flex items-center text-[#c0392b] font-sans font-bold text-sm uppercase tracking-widest hover:underline transition-colors" data-id="element-219">
            <span data-id="element-220">Ver cómo obtener tu guía</span>
            <ArrowDown className="ml-2 w-4 h-4" data-id="element-221" />
          </a>
        </div>
      </div>
    </section>;
}